import { view } from '@yola/ws-sdk';
import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import getTargetElementIds from 'src/js/modules/element-settings/helpers/get-target-element-ids';
import isAttributeMigrated from './is-attribute-migrated';

const buildLegacyMigrationBatch = (elementIdsByScope, legacyAttributes, state = {}) => {
  const batch = {};

  legacyAttributes.forEach(({ scope, attribute, classes, childrenQuerySelector, convert }) => {
    const elementIds = elementIdsByScope[scope] || [];

    elementIds.forEach((elementId) => {
      if (isAttributeMigrated(state, elementId, attribute)) {
        return;
      }

      if (!view.verifiers.hasElementAttribute(elementId, attribute)) {
        return;
      }

      const attributeValue = view.accessors.getElementAttribute(elementId, attribute);
      const classElementIds = getTargetElementIds(elementId, childrenQuerySelector);
      const classValues = convert(attributeValue);

      classElementIds.forEach((classElementId) => {
        if (!batch[classElementId]) {
          batch[classElementId] = {};
        }

        classes.forEach((classTarget) => {
          batch[classElementId][classTarget] = classValues;
        });
      });

      if (!batch[elementId]) {
        batch[elementId] = {};
      }

      batch[elementId][attribute] = { [breakpointKeys.DEFAULT]: false };
    });
  });

  return batch;
};

export default buildLegacyMigrationBatch;
